import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Snackbar from "@material-ui/core/Snackbar";
import { StyledTextField } from "components/form/form-textfield";
import copy from "clipboard-copy";
import styles from "./styles/copy-to-clipboard.css.js";
import withStyles from "components/with-styles";
import Icon from "components/icon";
import { injectIntl } from "react-intl";

const CopyToClipboard = ({ intl, textToCopy, classes, className, name = "copy-to-clipboard", onClick, ...props }) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const handleCloseFeedback = useCallback(() => setShowFeedback(false), []);

  const handleCopyToClipboard = useCallback(
    () => {
      copy(textToCopy);
      setShowFeedback(true);
      onClick && onClick();
    },
    [onClick, textToCopy],
  );

  return (
    <div className={className}>
      <div className={classes.root}>
        <StyledTextField
          name={name}
          variant="filled"
          inputClasses={{
            input: classes.input,
          }}
          disabled
          className={classes.component}
          type="text"
          readOnly
          value={textToCopy}
        />
        <button className={cn(classes.component, classes.button)} onClick={handleCopyToClipboard}>
          <Icon name="file-copy" />
        </button>
      </div>
      <Snackbar
        open={showFeedback}
        onClose={handleCloseFeedback}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={intl.formatMessage({ id: "common.copied" })}
        {...props}
      />
    </div>
  );
};

CopyToClipboard.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Nombre del input
   */
  name: PropTypes.string,
  /**
   * Texto que se muestra para copiar
   */
  textToCopy: PropTypes.string,
  /**
   * Callback que se llama al clicar a copiar
   */
  onClick: PropTypes.func,
};

export default withStyles(styles)(injectIntl(CopyToClipboard));
